import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { ThemeProvider } from "@mui/material/styles";
import { GlobalTheme } from '../themes/GlobalTheme';
import { createTheme } from "@mui/material/styles";
import {
    BRAND_GOLD,
    BRAND_GOLD_FILL_05,
    BRAND_GOLD_FILL_10,
    brandGoldFlatTextSx,
} from './windowChrome/index.js';

const PrimaryMainTheme = createTheme({
    palette: {
        primary: {
            main: GlobalTheme.ButtonAppBar.Main
        }
    }
});

export const ButtonAppBar = () => {
    return (
        <ThemeProvider theme={PrimaryMainTheme}>
            <AppBar 
                position="static" 
                sx={{
                    background: "linear-gradient(135deg, rgba(30, 34, 38, 0.98) 0%, rgba(45, 45, 45, 0.95) 100%)",
                    backdropFilter: "blur(20px)",
                    WebkitBackdropFilter: "blur(20px)",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.4), 0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05)",
                    borderBottom: "1px solid rgba(244, 204, 142, 0.15)",
                    position: "relative",
                    overflow: "hidden",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: "1px",
                        background: "linear-gradient(90deg, transparent, rgba(244, 204, 142, 0.3), transparent)",
                    },
                    ...GlobalTheme.ButtonAppBar.Box
                }}
            >
                <Toolbar sx={{
                    minHeight: "70px",
                    padding: "0 24px",
                    position: "relative",
                    zIndex: 1,
                }}>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{
                            mr: 3,
                            color: BRAND_GOLD,
                            background: `linear-gradient(135deg, ${BRAND_GOLD_FILL_10} 0%, ${BRAND_GOLD_FILL_05} 100%)`,
                            borderRadius: "10px",
                            border: "1px solid rgba(244, 204, 142, 0.2)",
                            width: "48px",
                            height: "48px",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                            "&:hover": {
                                background: "linear-gradient(135deg, rgba(244, 204, 142, 0.15) 0%, rgba(244, 204, 142, 0.08) 100%)",
                                transform: "scale(1.05)",
                                boxShadow: "0 4px 16px rgba(0, 0, 0, 0.3)",
                                border: "1px solid rgba(244, 204, 142, 0.3)",
                            },
                            "&:active": {
                                transform: "scale(0.95)",
                            }
                        }}
                    >
                        <MenuIcon sx={{ fontSize: "24px" }} />
                    </IconButton>
                    
                    <Typography 
                        variant="h4" 
                        component="div" 
                        sx={{
                            flexGrow: 1,
                            fontFamily: 'montserrat-extraLight',
                            fontSize: "32px",
                            fontWeight: 300,
                            letterSpacing: "1px",
                            textShadow: "0 2px 4px rgba(0, 0, 0, 0.5)",
                            marginLeft: "8px",
                            ...brandGoldFlatTextSx(),
                        }}
                    >
                        GrainWave
                    </Typography>
                    
                    <Button 
                        color="inherit"
                        sx={{
                            color: BRAND_GOLD,
                            background: `linear-gradient(135deg, ${BRAND_GOLD_FILL_10} 0%, ${BRAND_GOLD_FILL_05} 100%)`,
                            borderRadius: "10px",
                            border: "1px solid rgba(244, 204, 142, 0.2)",
                            padding: "10px 24px",
                            fontSize: "16px",
                            fontWeight: 500,
                            letterSpacing: "0.5px",
                            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                            textTransform: "none",
                            "&:hover": {
                                background: "linear-gradient(135deg, rgba(244, 204, 142, 0.15) 0%, rgba(244, 204, 142, 0.08) 100%)",
                                transform: "translateY(-2px)",
                                boxShadow: "0 4px 16px rgba(0, 0, 0, 0.3)",
                                border: "1px solid rgba(244, 204, 142, 0.3)",
                            },
                            "&:active": {
                                transform: "translateY(0px)",
                            }
                        }}
                    >
                        Login
                    </Button>
                </Toolbar>
            </AppBar>
        </ThemeProvider>
    );
}

export default ButtonAppBar;